import React, { lazy } from 'react';
import styled from 'styled-components';

import { Field } from 'react-final-form';

import {
  Button as MuiButton,
  InputAdornment,
  TextField as MuiTextField,
} from '@mui/material';
import { Autocomplete as RffAutocomplete } from 'mui-rff';

import { Autocomplete as AC, AutocompleteOptionUser } from 'components';
import { FormInput, Icon } from 'components/ui';

import { SValidationError } from '../styled/appointmentAddDialog';

import { useTranslation } from 'react-i18next';

export const Autocomplete = ({
  resolveItem,
  dataId = 'date-autocomplete',
  ...props
}) => {
  return (
    <Field name={props.name}>
      {({ input, meta }) => {
        return (
          <>
            <AC
              {...input}
              {...props}
              data-id={dataId}
              renderOption={AutocompleteOptionUser}
            />

            {!meta.valid && meta.touched && (
              <SValidationError>{[meta.error]}</SValidationError>
            )}
          </>
        );
      }}
    </Field>
  );
};

export const SaveButton = ({ title, icon, ...props }) => {
  return (
    <MuiButton
      color="primary"
      variant="contained"
      style={{
        padding: '5px 20px',
        borderRadius: '10px',
        height: '32px',
      }}
      {...props}
    >
      <Icon icon={icon} mr={5} />
      {title}
    </MuiButton>
  );
};

export const SimpleAC = (props) => {
  return (
    <RffAutocomplete
      label={null}
      variant="outlined"
      forcePopupIcon={'auto'}
      getOptionValue={(option) => option.value}
      getOptionLabel={(option) => option.label}
      renderInput={(params) => {
        return (
          <FormInput
            {...params}
            name={props.name}
            placeholder={props.placeholder}
          />
        );
      }}
      {...props}
    />
  );
};

export const DateField = (props) => {
  const { t } = useTranslation();
  return (
    <Field name={props.name}>
      {({ input, meta }) => {
        return (
          <>
            <SDateField
              {...props}
              {...input}
              data-id="date-field"
              value={props.selectedTimeSlot}
              variant="outlined"
              onClick={props.onClick}
              error={meta.touched && meta.error}
              helperText={meta.touched && t(meta.error)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Icon icon="calendar" style={{ fontSize: 24 }} />s
                  </InputAdornment>
                ),
              }}
              {...props}
            />
          </>
        );
      }}
    </Field>
  );
};

export const SDateField = styled(MuiTextField)`
  && {
    width: 100%;
    transition: all 0.3s;
    .MuiInputBase-root {
      padding: 0 13px 0;
    }
    .MuiOutlinedInput-input {
      padding: 10px 0 8px 0;
      margin-left: 10px;
      min-height: 40px;
      box-sizing: border-box;
    }
    fieldset {
      transition: all 0.3s;
      top: 0;
      border-color: ${({theme}) => theme.palette.colors.gray200};
      border-radius: 5px;
    }
    legend {
      display: none;
    }
    .MuiOutlinedInput-multiline {
      min-height: 40px;
      border-radius: 5px;
      padding: 7px 0 6px 12px;
    }
    textarea {
      height: ${({ multiline }) =>
        multiline ? 'fit-content' : '40px'} !important;
    }
  }
`;
